export const numberFormat = ({
  locale = 'en-us',
  number,
  style = 'decimal',
  currency = 'EUR',
  display = 'short',
  digit = 1,
  notation = 'compact',
  currencyDisplay = 'narrowSymbol',
}) => {
  return new Intl.NumberFormat(locale, {
    style,
    currency,
    notation,
    maximumFractionDigits: digit,
    compactDisplay: display,
    currencyDisplay,
  }).format(number)
}
